"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _material = require("@mui/material");
var _constants = require("../../../utils/constants");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _theme = _interopRequireDefault(require("./theme"));
var _theme2 = _interopRequireDefault(require("../../../typography/theme"));
var _translations_context = _interopRequireDefault(require("../../../translations/translations_context"));
var _loading_spinner = _interopRequireDefault(require("../../loading_spinner"));
var _excluded = ["isOpen", "anchorEl", "children"],
  _excluded2 = ["dropdownProps", "anchorEl", "noResultsComponent"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var useFlyoutStyles = (0, _makeStyles["default"])({
  list: {
    backgroundColor: _theme["default"].list.backgroundColor,
    border: "1px solid ".concat(_theme["default"].list.borderColor),
    boxSizing: 'border-box',
    margin: '1px 0 0 -1px',
    width: 'calc(100% + 2px)',
    padding: 0,
    boxShadow: '0px 2px 6px rgba(21, 55, 44, 0.13)',
    borderRadius: '0px 0px 5px 5px',
    maxHeight: 'min(500px, calc(50vh - 80px))',
    overflow: 'auto',
    '[data-popper-placement="top-start"] &': {
      borderBottomWidth: '0'
    },
    '[data-popper-placement="bottom-start"] &': {
      borderTopWidth: '0'
    }
  },
  item: {
    color: _theme2["default"].colors.primary,
    fontFamily: _theme2["default"].fonts.sans,
    fontSize: '1rem',
    fontWeight: _theme2["default"].fontWeights.normal,
    lineHeight: '1.125rem'
  },
  highlightedItem: {
    backgroundColor: _theme["default"].listItem.highlightedColor
  },
  selectedItem: {
    backgroundColor: _theme["default"].listItem.selectedColor
  }
});
var FlyoutWrapper = function FlyoutWrapper(_ref) {
  var isOpen = _ref.isOpen,
    anchorEl = _ref.anchorEl,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledPopper, (0, _extends2["default"])({}, props, {
    open: isOpen,
    anchorEl: anchorEl,
    disablePortal: true,
    keepMounted: true,
    placement: "bottom-start",
    modifiers: [{
      name: 'flip',
      enabled: true
    }, {
      name: 'computeStyle',
      enabled: true,
      options: {
        gpuAcceleration: false
      }
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        altBoundary: true
      }
    }, {
      name: 'setPopperWidth',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
      },
      effect: function effect(_ref3) {
        var state = _ref3.state;
        // @ts-expect-error - TS2339 - Property 'offsetWidth' does not exist on type 'Element | VirtualElement'.
        state.elements.popper.style.width = "".concat(state.elements.reference.offsetWidth, "px");
      }
    }]
  }), children);
};
var ListItems = function ListItems(props) {
  var _virtualItems$0$start, _virtualItems$;
  var items = props.items,
    highlightedIndex = props.highlightedIndex,
    selectedItem = props.selectedItem,
    classes = props.classes,
    getItemProps = props.getItemProps,
    rowVirtualizer = props.rowVirtualizer,
    isPaginated = props.isPaginated,
    total = props.total,
    loadingStatus = props.loadingStatus;
  var translations = React.useContext(_translations_context["default"]);
  var virtualItems = rowVirtualizer.getVirtualItems();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      transform: "translateY(".concat((_virtualItems$0$start = (_virtualItems$ = virtualItems[0]) === null || _virtualItems$ === void 0 ? void 0 : _virtualItems$.start) !== null && _virtualItems$0$start !== void 0 ? _virtualItems$0$start : 0, "px)")
    }
  }, virtualItems.map(function (virtualRow) {
    var _item$level;
    var index = virtualRow.index;
    var isLoaderRow = isPaginated && virtualRow.index > items.length - 1;
    if (isLoaderRow) {
      return items.length <= total && loadingStatus === 'loading' && /*#__PURE__*/React.createElement(BaseFlyout.Loading, {
        key: "loader",
        height: virtualRow.size
      });
    }
    var item = items[index];
    var isHighlighted = index === highlightedIndex;
    var isSelected = item.label === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label);
    var isDisabled = item.disabled;
    var indentLevel = (_item$level = item.level) !== null && _item$level !== void 0 ? _item$level : 0;
    var className = function () {
      if (isHighlighted) {
        return "".concat(classes.item, " ").concat(classes.highlightedItem);
      } else if (isSelected) {
        return "".concat(classes.item, " ").concat(classes.selectedItem);
      } else {
        return classes.item;
      }
    }();
    var displayLabel = item.userCreated ? "".concat(translations.birch.dropdowns.create_item, " '").concat(item.label, "'") : item.label;
    return /*#__PURE__*/React.createElement(TieredListItem, (0, _extends2["default"])({
      ref: rowVirtualizer.measureElement,
      key: "".concat(item.value).concat(index),
      className: className,
      disabled: isDisabled
    }, getItemProps({
      item: item,
      index: index
    }), {
      indentlevel: indentLevel
    }), item.startAdornment, "".concat(displayLabel));
  }));
};
var ListBody = function ListBody(_ref4) {
  var dropdownProps = _ref4.dropdownProps,
    noResultsComponent = _ref4.noResultsComponent;
  var getItemProps = dropdownProps.getItemProps,
    highlightedIndex = dropdownProps.highlightedIndex,
    items = dropdownProps.items,
    selectedItem = dropdownProps.selectedItem,
    loadingStatus = dropdownProps.loadingStatus,
    rowVirtualizer = dropdownProps.rowVirtualizer,
    isEmpty = dropdownProps.isEmpty,
    isPaginated = dropdownProps.isPaginated,
    total = dropdownProps.total;
  var classes = useFlyoutStyles();
  if (loadingStatus === 'error') {
    return /*#__PURE__*/React.createElement(BaseFlyout.LoadingError, null);
  }
  if (!isPaginated && loadingStatus === 'loading') {
    return /*#__PURE__*/React.createElement(BaseFlyout.Loading, null);
  }
  if (loadingStatus === 'loaded' || isPaginated && loadingStatus === 'loading') {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: rowVirtualizer.getTotalSize()
      }
    }, loadingStatus === 'loaded' && isEmpty ? /*#__PURE__*/React.createElement(BaseFlyout.NoResultsFound, {
      className: classes.item,
      noResultsComponent: noResultsComponent
    }) : /*#__PURE__*/React.createElement(ListItems, {
      items: items,
      rowVirtualizer: rowVirtualizer,
      highlightedIndex: highlightedIndex,
      selectedItem: selectedItem,
      classes: classes,
      getItemProps: getItemProps,
      isPaginated: isPaginated,
      total: total,
      loadingStatus: loadingStatus
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
var BaseFlyout = function BaseFlyout(_ref5) {
  var dropdownProps = _ref5.dropdownProps,
    anchorEl = _ref5.anchorEl,
    noResultsComponent = _ref5.noResultsComponent,
    props = (0, _objectWithoutProperties2["default"])(_ref5, _excluded2);
  var getMenuProps = dropdownProps.getMenuProps,
    isOpen = dropdownProps.isOpen,
    parentRef = dropdownProps.parentRef;
  var classes = useFlyoutStyles();
  return /*#__PURE__*/React.createElement(FlyoutWrapper, (0, _extends2["default"])({
    anchorEl: anchorEl,
    isOpen: isOpen
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(_material.List, (0, _extends2["default"])({
    className: classes.list,
    style: {
      scroll: 'auto'
    },
    ref: parentRef
  }, getMenuProps({
    ref: dropdownProps.parentRef
  })), /*#__PURE__*/React.createElement(ListBody, {
    dropdownProps: dropdownProps,
    anchorEl: anchorEl,
    noResultsComponent: noResultsComponent
  })));
};
var StyledPopper = (0, _styledComponents["default"])(_material.Popper).withConfig({
  displayName: "flyout__StyledPopper"
})(["z-index:", ";"], _constants.Z_INDEX_MAP.flyout);
var NoResultsFoundListItem = (0, _styledComponents["default"])(_material.ListItem).withConfig({
  displayName: "flyout__NoResultsFoundListItem"
})(["&&{color:", ";}"], _theme["default"].listItem.noResultsColor);
var NoResultsFound = function NoResultsFound(props) {
  var className = props.className,
    noResultsComponent = props.noResultsComponent;
  var translations = React.useContext(_translations_context["default"]);
  return (
    /*#__PURE__*/
    // Using ListItem in a styled component produces an error since the type exepects button prop
    // However, passing this prop in with the expected value of "true" strips this element of the
    // styles we intend to extend for some reason
    React.createElement(NoResultsFoundListItem, {
      className: className,
      "data-provides": 'no-results-found-item'
    }, noResultsComponent || translations.birch.dropdowns.no_results)
  );
};
BaseFlyout.NoResultsFound = NoResultsFound;
// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type '(props: NoResultsFoundProps) => Element'.
BaseFlyout.NoResultsFound.displayName = 'BaseFlyout.NoResultsFound';
// @ts-expect-error - TS2339 - Property 'defaultProps' does not exist on type '(props: NoResultsFoundProps) => Element'.
BaseFlyout.NoResultsFound.defaultProps = {
  children: 'No Results Found'
};
var CenteredListItem = (0, _styledComponents["default"])(_material.ListItem).withConfig({
  displayName: "flyout__CenteredListItem"
})(["&&{display:flex;justify-content:center;", "}"], function (_ref6) {
  var height = _ref6.height;
  return height && "height: ".concat(height, "px;");
});
BaseFlyout.Loading = function (props) {
  return (
    /*#__PURE__*/
    // @ts-expect-error - TS2769 - No overload matches this call.
    React.createElement(CenteredListItem, {
      height: props.height
    }, /*#__PURE__*/React.createElement(_loading_spinner["default"], {
      size: "small"
    }))
  );
};
// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type '() => Element'.
BaseFlyout.Loading.displayName = 'BaseFlyout.Loading';
var ErrorListItem = (0, _styledComponents["default"])(_material.ListItem).withConfig({
  displayName: "flyout__ErrorListItem"
})(["color:", ";"], _theme["default"].listItem.errorColor);
var LoadingError = function LoadingError() {
  var translations = React.useContext(_translations_context["default"]);
  return /*#__PURE__*/React.createElement(ErrorListItem, null, translations.birch.dropdowns.error_loading_results);
};
BaseFlyout.LoadingError = LoadingError;
// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type '() => Element'.
BaseFlyout.LoadingError.displayName = 'BaseFlyout.LoadingError';
var TieredListItem = (0, _styledComponents["default"])(_material.ListItem).withConfig({
  displayName: "flyout__TieredListItem"
})(["&&{", " padding-left:", "rem;gap:0.5rem;", " width:100%;}"], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return 1 + props.indentlevel * 1.5;
}, function (_ref7) {
  var height = _ref7.height;
  return height && "height: ".concat(height, "px;");
});
var _default = exports["default"] = BaseFlyout;